
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import CourseItem from "@/components/CourseItem.vue";
import { AxiosResponse } from "axios";
import { Action } from "vuex-class";
import ContentFooter from "@/components/ContentFooter.vue";

@Component({
  components: {
    CourseItem,
    AppLayout,
    ContentFooter,
  },
  filters,
})
export default class Courses extends Vue {
  @Action("getCategory", { namespace: "general" })
  private getCategory: any;
  @Action("getBundleCourse", { namespace: "bundleCourse" })
  private getBundleCourse: any;
  @Action("getCourse", { namespace: "course" })
  private getCourse: any;

  private categories = [];
  private bundleCourses = [];
  private bundleCourseTotal = 0;
  private bundleCourseSearch = "";
  private bundleCourseCategory: any = null;
  private bundleCourseFilter = "latest";
  private courses = [];
  private courseTotal = 0;
  private courseSearch = "";
  private courseCategory: any = null;
  private courseFilter = "latest";

  @Watch("$route.query")
  private onQuery() {
    this.setSearch();
  }

  @Watch("bundleCourseSearch")
  private onBundleCourseSearch() {
    this.getBundleCourseData();
  }

  @Watch("bundleCourseCategory")
  private onBundleCourseCategory() {
    this.getBundleCourseData();
  }

  @Watch("bundleCourseFilter")
  private onBundleCourseFilter() {
    this.getBundleCourseData();
  }

  @Watch("courseSearch")
  private onCourseSearch() {
    this.getCourseData();
  }

  @Watch("courseCategory")
  private onCourseCategory() {
    this.getCourseData();
  }

  @Watch("courseFilter")
  private onCourseFilter() {
    this.getCourseData();
  }

  private get bundleCoursePagination() {
    return {
      perPage: 8,
      currentPage: 1,
      total: 0,
      items: [],
    };
  }

  private get coursePagination() {
    return {
      perPage: 8,
      currentPage: 1,
      total: 0,
      items: [],
    };
  }

  private created() {
    this.getCategory({
      success: (response: AxiosResponse) => {
        this.categories = response.data.data.data;
        this.setCategory();
      },
    });
    this.setSearch();
    this.getBundleCourseData();
    this.getCourseData();
  }

  private setSearch() {
    let search = this.$route.query?.search?.toString();
    this.bundleCourseSearch = search;
    this.courseSearch = search;
  }

  private setCategory() {
    let category = this.categories.find(
      (value: any) => value.id === this.$route.query?.category
    );
    this.bundleCourseCategory = category;
    this.courseCategory = category;
  }

  private getBundleCourseData(page: number = 1) {
    this.getBundleCourse({
      params: {
        page: page || 1,
        name: this.bundleCourseSearch,
        category: this.bundleCourseCategory?.id,
        filter: this.bundleCourseFilter,
        per_page: this.bundleCoursePagination.perPage,
      },
      success: (response: AxiosResponse) => {
        this.bundleCourses = response.data.data.data;
        this.bundleCourseTotal = response.data.data.total;
        this.bundleCoursePagination.total = response.data.data.total;
        this.bundleCoursePagination.items = response.data.data.data;
        this.bundleCoursePagination.currentPage = response.data.data.current_page;
      },
    });
  }

  private getCourseData(page: number = 1) {
    this.getCourse({
      params: {
        page: page || 1,
        name: this.courseSearch,
        category: this.courseCategory?.id,
        filter: this.courseFilter,
        per_page: this.coursePagination.perPage,
      },
      success: (response: AxiosResponse) => {
        this.courses = response.data.data.data;
        this.courseTotal = response.data.data.total;
        this.coursePagination.total = response.data.data.total;
        this.coursePagination.items = response.data.data.data;
        this.coursePagination.currentPage = response.data.data.current_page;
      },
    });
  }
}
